function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M15.36 7.68L7.68 0 0 7.68l7.68 7.67z",
  fill: "#fff",
  fillRule: "evenodd"
});

function SvgDiamond(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15.34 15.34"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNS4zNCAxNS4zNCI+PHBhdGggZD0iTTE1LjM2IDcuNjhMNy42OCAwIDAgNy42OGw3LjY4IDcuNjd6IiBmaWxsPSIjZmZmIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4=";
export { SvgDiamond as ReactComponent };